var tri = require("tripartite"); var t = "<div class=\"zip-summary\">\n\t<strong>Zip Code:<\/strong> __center__\n<\/div>"; 
module.exports = tri.addTemplate("views/search-client/zip-summary", t); 